module.exports = __webpack_public_path__ + "static/media/circle-import.dc3d5d80.svg";